<template>
    <div class="section">
        <div class="bak">
            <h1 class="title is-size-2 is-size-3-mobile has-text-primary">Hotellbloggen</h1>
            <p class="is-size-5 is-size-6-mobile has-text-white">Disse sidene er under oppgradering. </p>
        </div>
    </div>
</template>

<script>
export default {
    title: 'Hotellbloggen byr på gode oppskrifter',
    metaInfo: {
        meta: [
        { name: 'description', content: 'Hotellbloggen. Innimellom skriver vi ned noen oppskrifter som vi deler. Litt etter innfallsmetoden - og hva vi synes er godt akkurat nå.'},
        { name: 'keywords', content: 'oppskrifter, blogg, hotellbloggen, matoppskrifter' }
        ]
    },       
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.7;
    display: block;
    padding: 10px 10px 10px 10px;
    margin-bottom:300px;
}
</style>